(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/calendar/assets/javascripts/date-field.js') >= 0) return;  svs.modules.push('/components/components/calendar/assets/javascripts/date-field.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

((svs, React) => {
  'use strict';

  const {
    Component
  } = React;
  const {
    ReactIcon
  } = svs.ui;
  const {
    Input
  } = svs.ui.form;
  const {
    format,
    isToday,
    isTomorrow,
    isYesterday
  } = dateFns;
  class DateField extends Component {
    constructor(props) {
      super(props);
      this.handleOnSet = this.handleOnSet.bind(this);
      this.toggleClick = this.toggleClick.bind(this);
      this.dateInputRef = React.createRef();
      this.containerRef = React.createRef();
      this.processSelect = false;
    }
    componentDidMount() {
      const options = {
        clear: false,
        close: 'Stäng',
        container: this.containerRef.current,
        editable: false,
        isTodayOrTomorrow: false,
        klass: {
          buttonClose: 'calendar-close-button',
          month: 'inline-block padding-xs-h padding-xs-v-1 f-bold',
          navNext: 'calendar-right-arrow icon-default icon-menu-right js-next padding-xs-1 pointer',
          navPrev: 'calendar-left-arrow icon-default icon-menu-left js-previous padding-xs-1 pointer',
          opened: 'picker--opened',
          picker: 'picker date-picker-default',
          weekdays: 'f-bold padding-xs-bottom',
          year: 'inline-block padding-xs-h padding-xs-v-1'
        },
        labelMonthNext: 'Nästa månad',
        labelMonthPrev: 'Föregående månad',
        openCloseInput: false,
        today: false,
        weekdaysShort: ['S', 'M', 'T', 'O', 'T', 'F', 'L']
      };
      const $picker = $(this.dateInputRef.current).pickadate(_objectSpread(_objectSpread(_objectSpread({}, options), this.props.pickadateOptions), {}, {
        onSet: this.handleOnSet
      }));
      this.picker = $picker.pickadate('picker');
      this.picker.set('select', this.props.inputProps.value);
      this.processSelect = true;
      const self = this;
      if (this.props.pickadateOptions.isOpen) {
        this.picker.on({
          close: () => {
            self.picker.isOpen = false;
            self.props.pickadateOptions.isOpen({
              open: false
            });
          },
          open: () => {
            self.picker.isOpen = true;
            self.props.pickadateOptions.isOpen({
              open: true
            });
          }
        });
      }
      if (this.props.pickadateOptions.openCloseInput) {
        const $clicker = $('.open-close-clicker');
        $clicker.off('click');
        $clicker.on('click', this.toggleClick);
      }
    }
    componentDidUpdate(_ref) {
      let {
        pickadateOptions,
        inputProps
      } = _ref;
      if (pickadateOptions !== this.props.pickadateOptions) {
        this.picker.set(this.props.pickadateOptions);
      }
      if (inputProps.value.valueOf() !== this.props.inputProps.value.valueOf()) {
        this.processSelect = false;
        this.picker.set('select', this.props.inputProps.value);
        this.processSelect = true;
      }
    }
    toggleClick(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.picker.get('open')) {
        this.picker.close();
      } else {
        this.picker.open();
      }
    }

    handleOnSet(event) {
      const todayOrTomorrow = date => {
        if (this.props.pickadateOptions.isTodayOrTomorrow) {
          if (isToday(date)) {
            return 'Idag - ';
          } else if (isTomorrow(date)) {
            return 'Imorgon - ';
          } else if (isYesterday(date)) {
            return 'Igår - ';
          }
        }
        return '';
      };
      if (!this.processSelect) {
        this.dateInputRef.current.value = todayOrTomorrow(this.props.inputProps.value) + this.props.format(this.props.inputProps.value);
        return;
      }
      if (event.select) {
        const select = this.picker.get('select');
        if (this.props.format) {
          this.dateInputRef.current.value = todayOrTomorrow(select.obj) + this.props.format(select.obj);
        }
        this.props.onChange({
          day: select.date,
          month: select.month,
          obj: select.obj,
          year: select.year
        });
      }
      if (event.highlight) {
        const view = this.picker.get('view');
        if (this.props.onViewChange) {
          this.props.onViewChange(view);
        }
      }
    }
    renderContainer() {
      const {
        isAbove
      } = this.props;
      const classNames = ['relative'];
      if (isAbove) {
        classNames.push('is-above');
      }
      return React.createElement("div", {
        className: classNames.join(' '),
        ref: this.containerRef
      });
    }
    renderClicker() {
      return React.createElement("div", {
        className: "open-close-clicker",
        style: {
          position: 'absolute',
          height: 44,
          width: 'inherit',
          zIndex: 400
        }
      });
    }
    render() {
      const {
        isAbove,
        inputProps,
        format,
        pickadateOptions
      } = this.props;
      const {
        openCloseInput
      } = pickadateOptions;
      return React.createElement(React.Fragment, null, isAbove && this.renderContainer(), openCloseInput && this.renderClicker(), React.createElement(Input, {
        className: "js-input js-datefield-input std-input",
        "data-testid": "date-input",
        readOnly: true,
        refElem: this.dateInputRef,
        suffix: React.createElement(ReactIcon, {
          icon: inputProps.icon ? inputProps.icon : 'calendar',
          size: "100"
        }),
        type: "button",
        value: format(inputProps.value)
      }), !isAbove && this.renderContainer());
    }
  }
  DateField.defaultProps = {
    format: date => format(new Date(date), 'yyyy-MM-dd'),
    inputProps: {
      placeholder: 'Välj datum',
      value: new Date()
    },
    isAbove: false,
    onChange: () => {},
    onViewChange: null,
    pickadateOptions: {}
  };
  svs.components.DateField = DateField;
})(svs, React);

 })(window);